import { BulkGradingWrapper } from './BulkGradingWrapper';

export default BulkGradingWrapper;
